import React from 'react';
import { Routes, Route } from 'react-router';
import Home from './home';
import Shop from './shop';
import Cart from './cart';
import Contact from './contact';
import ProductDetail from './product-detail';

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Rout = ({ shop, Filter, allcatefilter, addtocart, cart, setCart }) => {
  return (
    <>
      {/* Toastify Notification System */}
      <ToastContainer 
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop
        pauseOnHover
        theme="light"
      />

      <Routes>
        <Route path='/' element={<Home addtocart={addtocart} />} />
        <Route path='/cart' element={<Cart cart={cart} setCart={setCart} />} />
        <Route 
          path='shop' 
          element={<Shop shop={shop} Filter={Filter} allcatefilter={allcatefilter} addtocart={addtocart} />} 
        />
        <Route path='/contact' element={<Contact />} />
        <Route path='/product-detail/:id' element={<ProductDetail addtocart={addtocart} />} />
      </Routes>
    </>
  );
};

export default Rout;
